export default "__VITE_ASSET__62071996__"